import { FC, useRef } from 'react';

import { Icon } from '@purpur/library/icon';
import { filter } from '@purpur/library/icon/assets/filter';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { Facets } from '@telialt/core-search/src/Common/Facets/Facets';
import { DrawerOpenButton, DrawerOpenButtonName } from '@telialt/core-search/src/Common/Facets/Facets.styles';
import { SEARCH_TEST_ID } from '@telialt/core-search/src/test/test-ids';

import { FacetFilteringControls } from './model';
import { PlansCustomDrawer } from './PlansFacetsDrawer.styles';

type Props = Pick<FacetFilteringControls, 'facets' | 'filters' | 'onFilterChange' | 'onRemoveAllFilters'>;

export const PlansFacetsDrawer: FC<Props> = ({ facets, filters, onFilterChange, onRemoveAllFilters }) => {
    const { t } = useTranslations();
    const triggerButtonRef = useRef<HTMLButtonElement>(null);

    return (
        <PlansCustomDrawer
            triggerButtonRef={triggerButtonRef}
            id="search-facets-drawer"
            triggerButton={(onClick, isOpen) => (
                <DrawerOpenButton
                    ref={triggerButtonRef}
                    onClick={onClick}
                    aria-expanded={!!isOpen}
                    aria-controls="search-facets-drawer"
                    data-test={SEARCH_TEST_ID.FACETS_DRAWER_OPEN_BUTTON}
                >
                    <DrawerOpenButtonName>{t['plans.plans_list.facets_drawer.open_button']}</DrawerOpenButtonName>
                    <Icon svg={filter} size="md" />
                </DrawerOpenButton>
            )}
            title={t['plans.plans_list.facets_drawer.heading']}
            closeButton={{ title: t['plans.plans_list.facets_drawer.filter_button'], variant: 'primary' }}
            clearButton={{ title: t['plans.plans_list.facets_drawer.delete_filters'], variant: 'secondary' }}
            onClear={onRemoveAllFilters}
            dataTest={SEARCH_TEST_ID.RESULTS_PRODUCTS_FACETS_DRAWER}
        >
            <Facets facets={facets} filters={filters} showCount={true} onChange={onFilterChange} />
        </PlansCustomDrawer>
    );
};
